import styled from 'styled-components';

export const Container = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(288px, 446px));
  justify-content: flex-start;
  gap: 22px;
  padding: 8px 8px 10px;
  overflow-x: auto;
  overflow-y: visible;
  margin: -8px -8px 30px;
`;

export const Card = styled.article`
  display: flex;
  width: 100%;
  max-width: 446px;
  min-width: 288px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #edf0f5;
  border-radius: 22px;
  background: #fbfbfb;
  box-shadow: 0px 2px 6px 0px #2124291a;
`;

export const Image = styled.img`
  width: calc(100% - 32px);
  height: 195px;
  margin: 16px 16px 0;
  border-radius: 10px;
  object-fit: cover;
  object-position: center;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 17px 16px 16px;
`;

export const Title = styled.h2`
  margin: 0 0 9px;
  color: #33373c;
  font-size: 22px;
  font-weight: 700;
  line-height: 25px;
`;

export const Description = styled.p`
  margin: 0 0 16px;
  color: #525252;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
`;

export const ButtonIcon = styled.img`
  width: 11px;
  height: 11px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 34px;
  margin-top: auto;
  border: 2px solid #0c50d3;
  border-radius: 18px;
  background: #fbfbfb;
  color: #0c50d3;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  gap: 12px;

  &:hover,
  &:focus-visible {
    background: #eaf4ff;
    border-color: #0969f0;
    color: #0969f0;
    box-shadow: 0px 4px 8px 0px #33373c29;
  }

  &:active {
    background: #d7edff;
    border-color: #0c50d3;
    color: #0c50d3;
    box-shadow: none;
  }
`;
